import _ from 'lodash';
import { FC } from 'react';
import ErrorMessage from 'common/components/ErrorMesssage';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';

const AngleBroking: FC<BrokerSpecificComponentsProps> = ({
  userConfigs,
  brokerSpecificHandles,
  switchPage,
}) => {
  const { validateClientId, updatePartialConfigs, validateTotp, changeApiKey } = brokerSpecificHandles;

  const {
    brokerExtras,
    brokerErrorMessage,
    clientId,
    totp,
    pin,
    isClientValidated,
    shouldShowApiKey,
    shouldShowSecretKey,
    secretKey,
    apiKey,
    selectedBrokerConfig,
    isLoading,
  } = userConfigs;

  const broker = selectedBrokerConfig?.id;

  const onSaveAction = () => {
    if (!isClientValidated) {
      return validateClientId({ broker_user_id: clientId });
    }
    if (isClientValidated) {
      return validateTotp({ extras: brokerExtras, pin: pin }, true);
    }
    return () => {};
  };

  const btnLabel = () => {
    if (!isClientValidated) {
      return 'Validate';
    }

    return 'Login';
  };

  return (
    <form
      id={`${broker}-otp-form`}
      onSubmit={(e) => {
        e.preventDefault();
        onSaveAction();
      }}
    >
      <UserInput
        labelValue="Client ID"
        id={`${broker}-client-id`}
        value={clientId}
        isDisabled={isClientValidated}
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />

      {shouldShowApiKey && (
        <UserInput
          labelValue="Api Key"
          id={`${broker}-api-key`}
          value={apiKey}
          onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
        />
      )}

      {shouldShowSecretKey && (
        <UserInput
          labelValue="Secret Key"
          id={`${broker}-secret-key`}
          value={secretKey}
          type="password"
          placeholder="Enter Secret Key"
          onHandleChange={(value) => updatePartialConfigs({ secretKey: value })}
        />
      )}

      {shouldShowApiKey && (
        <button type="button" onClick={() => switchPage()}>
          <i className="fa-regular fa-gear fa-spin" />
          Steps to get API key and Secret key details?
        </button>
      )}

      {isClientValidated && !shouldShowApiKey && (
        <button type="button" onClick={() => changeApiKey()}>
          <i className="fa-regular fa-gear fa-spin" />
          Change in API key details?
        </button>
      )}

      {isClientValidated && (
        <UserInput
          labelValue="PIN"
          type="text"
          id={`${broker}-pin`}
          value={pin}
          onHandleChange={(value) => updatePartialConfigs({ pin: value })}
        />
      )}

      {isClientValidated && (
        <UserInput
          labelValue="TOTP"
          type="text"
          id={`${broker}-totp`}
          value={totp ?? ''}
          onHandleChange={(value) => updatePartialConfigs({ totp: value })}
        />
      )}

      <ErrorMessage error={{ message: _.capitalize(_.startCase(brokerErrorMessage)) }} />

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-otp-form`} type="submit" isLoading={isLoading}>
          {btnLabel()}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default AngleBroking;
